import { getMenusList } from '@/api/login'
import { debug } from 'util';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(title, menuData) {
  if (menuData[title]) {
    return true
  } else {
    return false
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(datas, menuData) {
  for (let i = 0; i < datas.length; i++) {
    if (menuData.menu_id === datas[i].parent_id) {
      datas[i].children = []
      datas[i].meta = {}
      datas[i].meta.icon = datas[i].icon !== undefined ? datas[i].icon : ''
      datas[i].meta.title = datas[i].title
      datas[i].meta.name= datas[i].name
      menuData.children.push(datas[i])
      filterAsyncRouter(datas, datas[i])
    }
  }
}

const permission = {
  state: {
    menus: [],
    recodeMenu: []
  },
  mutations: {
    SET_MENUS: (state, routers) => {
      state.menus = routers
    },
    SET_RECODEMENU: (state, recodeData) => {
      state.recodeMenu = recodeData
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        getMenusList().then(response => {
          const datas = response.data.data
          let recodeData = []
          datas.forEach((item) => {
            recodeData.push({
              menuId: item.menu_id,
              href: item.href
            })
          })
          commit('SET_RECODEMENU', recodeData)
          const menuData = []
          if (datas && datas !== '') {
            if (response.data.code === '200') {
              for (let i = 0; i < datas.length; i++) {
                if (datas[i].parent_id === -1) {
                  datas[i].children = []
                  datas[i].meta = {}
                  datas[i].meta.icon = undefined !== datas[i].icon ? datas[i].icon : ''
                  datas[i].meta.title = datas[i].title
                  datas[i].meta.name = datas[i].name
                  menuData.push(datas[i])
                }
              }

              for (let i = 0; i < menuData.length; i++) {
                filterAsyncRouter(datas, menuData[i])
              }

              commit('SET_MENUS', menuData)
              resolve()
            } else {
              commit('SET_MENUS', [])
              resolve()
            }
          }else{
            commit('SET_MENUS', [])
            resolve()
          }
        })
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js